import { TradeToEarnCampaignStatus, TradeToEarnCampaignSummary, TradeToEarnCampaignWithStats } from "@cede/types";
import { SUPPORTED_EXCHANGES } from "@cede/types";

export const CAMPAIGN_STATUS = {
  LIVE: "live",
  FUTURE: "future",
  PAST: "past",
  PAUSED: "paused",
} as const;

export type CampaignStatusType = TradeToEarnCampaignStatus;
export interface CampaignWithStats extends TradeToEarnCampaignWithStats {
  isParticipating: boolean;
  currentVolume: number;
  totalVolume: number;
  participantCount: number;
}

export interface CampaignSummaryWithStats extends TradeToEarnCampaignSummary {
  isParticipating: boolean;
  currentVolume: number;
  totalVolume: number;
  participantCount: number;
}

export const SortOptions = {
  DATE_ASC: "createdAt:asc",
  DATE_DESC: "createdAt:desc",
  REWARD_ASC: "currentEpochReward:asc",
  REWARD_DESC: "currentEpochReward:desc",
  VOLUME_ASC: "currentVolume:asc",
  VOLUME_DESC: "currentVolume:desc",
  STATUS_ASC: "status:asc",
  STATUS_DESC: "status:desc",
  EXCHANGE_ASC: "exchange:asc",
  EXCHANGE_DESC: "exchange:desc",
  CAMPAIGN_NAME_ASC: "name:asc",
  CAMPAIGN_NAME_DESC: "name:desc",
  EPOCH_END_ASC: "epochEnd:asc",
  EPOCH_END_DESC: "epochEnd:desc",
} as const;

export type SortOptionType = (typeof SortOptions)[keyof typeof SortOptions];

export type SortDirection = "asc" | "desc";
export type SortField =
  | "createdAt"
  | "currentEpochReward"
  | "currentVolume"
  | "status"
  | "exchange"
  | "name"
  | "epochEnd";

export interface SortState {
  field: SortField;
  direction: SortDirection;
}

export const ParticipationFilter = {
  PARTICIPATING: "participating",
  NOT_PARTICIPATING: "not_participating",
} as const;

export type ParticipationFilterType = (typeof ParticipationFilter)[keyof typeof ParticipationFilter];

export const RewardView = {
  DAILY: "daily",
  PER_EPOCH: "perEpoch",
} as const;

export type RewardViewType = (typeof RewardView)[keyof typeof RewardView];

export const SUPPORTED_HUB_EXCHANGES = Object.fromEntries(
  Object.values(SUPPORTED_EXCHANGES).map((exchange) => [exchange.toUpperCase(), exchange]),
);

export type ExchangeType = (typeof SUPPORTED_HUB_EXCHANGES)[keyof typeof SUPPORTED_HUB_EXCHANGES];
